
export function TableCopyButton({tableId, className, children}: {tableId: string, className?: string, children: React.ReactNode}) {

    const copyTableToClipboard = (id) => {
        const elTable = document.getElementById(id);

        // Ensure that range and selection are supported by the browsers
        if (document.createRange && window.getSelection) {

            const range = document.createRange();
            const sel = window.getSelection();
            // unselect any element in the page
            sel.removeAllRanges();

            try {
                range.selectNodeContents(elTable);
                sel.addRange(range);
            } catch (e) {
                range.selectNode(elTable);
                sel.addRange(range);
            }

            document.execCommand('copy');
            sel.removeAllRanges();
        }

    }

    return (
        <button className={className} onClick={() => copyTableToClipboard(tableId)}>{children}</button>
    )
}